import { SentimentSatisfiedAlt } from '@mui/icons-material';
import { CircularProgress, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { FC } from 'react';
import CenteredContainer from 'src/components/atoms/CenteredContainer';

type Props = {
    noData: boolean;
};
export const DataTableNoRows: FC<Props> = ({ noData }) => {
    return (
        <StyledContainer positive={noData}>
            {noData ? (
                <>
                    <Typography
                        sx={{
                            fontWeight: 'bold',
                        }}
                    >
                        Phew! Looks like there are no styles in need of your attention
                    </Typography>
                    <SentimentSatisfiedAlt fontSize="small" color="success" />
                </>
            ) : (
                <>
                    <CircularProgress size="16px" />
                    <Typography>Loading...</Typography>
                </>
            )}
        </StyledContainer>
    );
};

const StyledContainer = styled(CenteredContainer)<{ positive: boolean }>(({ theme, positive }) => ({
    backgroundColor: positive ? alpha(theme.palette.success.light, 0.2) : 'inherit',
    border: positive ? `1px solid ${theme.palette.success.main} ` : `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    gap: theme.spacing(2.5),
}));
